import React from 'react';

const NoValue = ({text = '-'}) => {
    return <span className="text-gray-400">{text}</span>
}

export default NoValue;